import { Loading } from '@dvms/ui';

export default function LoadingPage() {
    return <Loading size="full" />;
}
